import { GetCompaniesBySearchParams } from '../../../global/adapters/crpAPI';

export const searchCompaniesKeys = {
  root: ['search-companies'] as const,
  getCompaniesBySearchParams: (params: GetCompaniesBySearchParams) =>
    [...searchCompaniesKeys.root, 'get-companies-by-search-params', params] as const,
};
